import { FilterItem } from '@/components/ui/custom/ComplexFilter/types';
import { getFilterValues, useTableFilters } from '@/hooks/useTableFilters';
import { Rule } from '@/shared/types/rules';

const filterRules = (rules: Rule[], filters: FilterItem[]) => {
  const statusValues = getFilterValues(filters, 'status');
  const triggeredByValues = getFilterValues(filters, 'triggeredBy');

  return rules.filter((rule) => {
    if (statusValues.length && !statusValues.includes(rule.status)) {
      return false;
    }
    if (triggeredByValues.length) {
      return rule.triggers?.some((trigger) => triggeredByValues.includes(trigger.type)) ?? false;
    }
    return true;
  });
};

/**
 * Hook to manage Rules page filtering with saved filter views.
 * Combines generic filters with Rules-specific filtering logic.
 */
export const useRulesFilters = (rules: Rule[] | undefined) => {
  const {
    filters,
    setFilter,
    removeFilter,
    resetFilters,
    activeFilterCount,
    savedViews,
    activeView,
    hasUnsavedChanges,
    saveView,
    updateView,
    deleteView,
    renameView,
    applyView,
    clearActiveView,
  } = useTableFilters({ storageKey: 'rulesFilters', preferencesKey: 'rules' });

  // Undefined while loading, so the list can tell loading apart from no rules.
  const filteredRules = rules && filterRules(rules, filters);

  return {
    filters,
    filteredRules,
    activeFilterCount,
    setFilter,
    removeFilter,
    resetFilters,
    savedViews,
    activeView,
    hasUnsavedChanges,
    applyView,
    clearActiveView,
    saveView,
    renameView,
    updateView,
    deleteView,
  };
};
